import PropTypes from 'prop-types'

const LinkPropTypes = {
  children: PropTypes.node.isRequired
}

export default LinkPropTypes
